import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';

import { userInfoStore } from '../../../store/userInfoStore';
import { isMobile } from '../../../core/helpers/isMobile';
import JackPot from '../../../components/common/jackpot';

const JackPotInfoWrapper = observer(() => {
  const { containerConfig } = useMemo(() => {
    return {
      containerConfig: {
        x: isMobile() ? 0 : 122,
        y: isMobile() ? 8 : 20,
      },
    };
  }, []);
  if (userInfoStore.isReplay) {
    return;
  }

  // eslint-disable-next-line consistent-return
  return <JackPot containerConfig={containerConfig} />;
});

export default JackPotInfoWrapper;
